/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GeraetDto } from '../../models/geraet-dto';

export interface GetAllGeraete$Plain$Params {
}

export function getAllGeraete$Plain(http: HttpClient, rootUrl: string, params?: GetAllGeraete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<GeraetDto>>> {
  const rb = new RequestBuilder(rootUrl, getAllGeraete$Plain.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<GeraetDto>>;
    })
  );
}

getAllGeraete$Plain.PATH = '/v1/geraete/all';
